import { Button, Flex, notification } from "antd";
import { FileExcelOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import CrearGrupoModal from "./Modal";
import { useState } from "react";
import dayjs from "dayjs";
import {
    blobCsvComparacionParametros,
    descargarBlobCsv,
} from "../../../../../Util/csvParametrosComparacion";

const CrearGrupo = ({ registros, isMuestra }) => {
    const [abrir, setAbrir] = useState(false);
    const [exportando, setExportando] = useState(false);

    if (!registros?.length) {
        return null;
    }

    const extraParam = isMuestra ? "muestra" : "prueba";
    const links = [
        { path: `/prueba/cuadrante/${registros}?extraParam=${extraParam}`, label: "Reporte de Cuadrante" },
        { path: `/prueba/ranking/${registros}?extraParam=${extraParam}`, label: "Ranking" },
    ];

    const exportarParametrosCsv = async () => {
        setExportando(true);
        try {
            const blob = await blobCsvComparacionParametros(registros, { isMuestra });
            if (!blob) {
                notification.error({ description: "No hay parámetros para exportar." });
                return;
            }
            const nombre = isMuestra ? "muestras" : "pruebas";
            descargarBlobCsv(blob, `parametros_${nombre}_${dayjs().format("DD-MM-YYYY")}.csv`);
            notification.success({ description: "CSV exportado correctamente." });
        } catch (err) {
            notification.error({
                description:
                    err?.response?.data?.mensaje ||
                    err?.message ||
                    err?.toString?.() ||
                    "No se pudo exportar el CSV.",
            });
        } finally {
            setExportando(false);
        }
    };

    return (
        <>
            <CrearGrupoModal abrir={abrir} cerrar={setAbrir} registros={registros} isMuestra={isMuestra} />
            <Flex gap="middle">
                <Button type="primary" onClick={() => setAbrir(true)}>
                    Crear muestra
                </Button>
                {links.map(({ path, label }) => (
                    <Link key={path} to={path}>
                        <Button type="primary">{label}</Button>
                    </Link>
                ))}
                <Button
                    type="primary"
                    icon={<FileExcelOutlined />}
                    loading={exportando}
                    onClick={exportarParametrosCsv}
                >
                    Exportar Parametros[csv]
                </Button>
            </Flex>
        </>
    );
};

export default CrearGrupo;
